import moment from 'moment';
import UploadModal from '../upload-modal/UploadModal.vue';
import pricingApi from '../../../../services/pricing.api';
import jwt from 'jsonwebtoken';

const token = process.env.VUE_APP_API_PRINCE_TOKEN;

export default {
  name: 'PrecificacaoList',
  props: ['subjectPermission'],
  components: {
    UploadModal,
  },
  data() {
    return {
      isModalOpen: false,
      itens: [],
      itemsPerPage: 50,
      currentPage: 1,
      selected: [],
      file: null,
      buttonLabel: 'Selecionar Arquivo',
      formData: {
        date: '',
        files: Array(3).fill(null),
      },
    };
  },
  computed: {
    statusColor() {
      return {
        Criado: 'primary',
        Concluído: 'success',
        Cancelado: 'danger',
        'Erro no Upload': 'warning',
        Processando: 'purple',
      };
    },
  },
  mounted() {
    this.getPrincings();
  },
  methods: {
    async getPrincings() {
      this.itens = await pricingApi.listPrices();
    },

    handleUploadSuccess() {
      this.getPrincings();
      this.closeModal();
    },

    formatDateBr(date) {
      return moment.parseZone(date).format('DD/MM/YYYY H:mm:ss');
    },

    showInactiveButton(tr) {
      const currentDate = new Date();

      const startDate = new Date(tr.startDate);
      const timezoneOffsetInHours = startDate.getTimezoneOffset() / 60;
      startDate.setHours(startDate.getHours() + timezoneOffsetInHours);

      return startDate > currentDate && tr.status === 'Concluído';
    },

    async downloadZipFile(fileUrl) {
      try {
        const response = await fetch(fileUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Erro ao baixar o arquivo');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        const fileName = fileUrl.split('/').pop() || 'download.zip';
        a.download = fileName;

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Erro ao fazer download do arquivo.`,
          color: 'danger',
        });
        console.error('Erro ao fazer download do arquivo', error);
      }
    },

    getStatusColor(status) {
      return this.statusColor[status];
    },

    async openModal() {
      const response = await pricingApi.canCreateNewVersion();

      if (response.can_create) {
        this.isModalOpen = true;
        return;
      }

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: `Não é possível criar uma nova versão, pois já existe uma versão programada para o futuro.`,
        color: 'danger',
      });
    },

    closeModal() {
      this.isModalOpen = false;
    },

    confirmInactive(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Inativar versão`,
        text: 'Tem certeza que deseja inativar essa versão?',
        acceptText: 'Sim',
        cancelText: 'Não',
        accept: () => this.inactive(id),
      });
    },

    inactive(id) {
      const payload = {
        status: 'Cancelado',
      };

      pricingApi.inactiveVersion(id, payload).then((response) => {
        this.$vs.notify({
          color: 'success',
          title: 'Atenção',
          text: 'Versão inativada com sucesso.',
        });

        this.getPrincings();
      });
    },
  },
};
